import React from 'react';
import { useTheme } from "@mui/styles";
import { useSelector } from 'react-redux';
import { selectClosureTypePieChartData } from '../../slices/teamStatsSlice';
import AnalyticsPieCard from '../../pages/Dashboard/components/RenegotiationsOverview/components/AnalyticsPieCard';

const ClosuresPieChart = () => {
  const theme = useTheme();

  const pieChartData = useSelector(selectClosureTypePieChartData)
  
  const COLORS = [`${theme.closure.renegotiation.primary}`, `${theme.closure.refinance.pieChart}`];
  
  return (
    <AnalyticsPieCard
      title="Closure Types"
      pieChartData={pieChartData || []}
      colors={COLORS}
      legendItems={[
        { label: "Renegotiations", value: pieChartData !== undefined ? pieChartData[0].size : <></>, color: theme.closure.renegotiation.primary },
        { label: "Refinances", value: pieChartData !== undefined ? pieChartData[1].size : <></>, color: theme.closure.refinance.pieChart },
      ]}
      emptyText="no closures"
      loading={pieChartData === undefined}
    />
  )
}

export default ClosuresPieChart;
